import React from 'react';
import ReactDOM from 'react-dom';
import Table from './src/components/Table';
import ExpandableHTML from './src/components/ExpandableHTML';
import LocationList from './src/components/LocationList';

const render = (tag) => {
  ReactDOM.render(<div>hello react</div>, document.getElementById(tag));
};

// TODO: is this the type of api that we want to expose to the portal to render stuff?
const renderTable = (tag, props) => {
  ReactDOM.render(<Table {...props} />, document.getElementById(tag));
};


export {
  render,
  renderTable,
  ExpandableHTML,
  LocationList,
};
